import { createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "카테고리", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: "SEA" }, "바다", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: "FRESH" }, "민물", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "어종 코드 한글 명", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", null, "정렬 순서", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "form-group mb-5" }
const _hoisted_20 = {
  class: "c-switch c-switch-pill c-switch-primary",
  style: {"width":"50px"}
}
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "사용여부", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", {
  class: "c-switch-slider",
  style: {"width":"40px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.category = $event)),
                required: ""
              }, [
                _hoisted_7,
                _hoisted_8
              ], 512), [
                [_vModelSelect, _ctx.category]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.code_kor_name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.code_kor_name]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.order_idx = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.order_idx]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("label", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.use_yn_bool = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.use_yn_bool]
                ]),
                _hoisted_22
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "Add new",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}